import React from 'react';
import { Box, Avatar, Typography, Chip } from '@mui/material';
import ArticleIcon from '@mui/icons-material/Article';
import VideocamOutlinedIcon from '@mui/icons-material/VideocamOutlined';
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import ThumbUpAltOutlinedIcon from '@mui/icons-material/ThumbUpAltOutlined';
import ThumbDownAltOutlinedIcon from '@mui/icons-material/ThumbDownAltOutlined';

const countAttachmentsByType = (attachments) => {
  const list = Array.isArray(attachments) ? attachments : [];
  const videos = list.filter((a) => a.mediaType === 'video').length;
  const images = list.filter((a) => a.mediaType === 'image').length;
  const docs = list.filter((a) => a.mediaType === 'document' || a.mediaType === 'raw').length;
  return { videos, images, docs };
};

const KBListItem = ({ article, onClick }) => {
  const { videos, images, docs } = countAttachmentsByType(article.attachments);
  const totalAttach = videos + images + docs;

  return (
    <Box
      onClick={onClick}
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: 2.5,
        p: 2.5,
        borderRadius: 2,
        cursor: 'pointer',
        border: '1px solid #e2e8f0',
        bgcolor: 'white',
        transition: 'all 0.2s',
        minHeight: 80,
        '&:hover': {
          bgcolor: 'action.hover',
          borderColor: '#cbd5e1',
          boxShadow: 1,
        },
      }}
    >
      <Avatar variant="rounded" sx={{ width: 48, height: 48, bgcolor: '#22419e', flexShrink: 0 }}>
        <ArticleIcon sx={{ color: 'white', fontSize: 24 }} />
      </Avatar>

      <Box sx={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', gap: 0.75 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
          <Typography variant="body1" fontWeight={700} sx={{ fontSize: '1.05rem' }} noWrap>
            {article.title}
          </Typography>
          <Chip
            label={article.moduleName || article.moduleSlug}
            size="medium"
            sx={{
              flexShrink: 0,
              fontWeight: 700,
              fontSize: '0.85rem',
              bgcolor: 'rgba(34, 65, 158, 0.08)',
              color: '#22419e',
              border: '1px solid rgba(34, 65, 158, 0.25)',
              height: 28,
            }}
          />
        </Box>
        {article.shortDescription && (
          <Typography variant="body2" color="text.secondary" noWrap sx={{ display: 'block', fontSize: '0.9rem' }}>
            {article.shortDescription}
          </Typography>
        )}
      </Box>

      <Box sx={{ flexShrink: 0, display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 0.75, minWidth: 150 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap', justifyContent: 'flex-end' }}>
          {totalAttach > 0 && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              {videos > 0 && (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.3 }}>
                  <VideocamOutlinedIcon sx={{ fontSize: 18, color: '#0ea5e9' }} />
                  <Typography sx={{ fontSize: 14, color: '#0ea5e9', fontWeight: 700 }}>{videos}</Typography>
                </Box>
              )}
              {images > 0 && (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.3 }}>
                  <ImageOutlinedIcon sx={{ fontSize: 18, color: '#6366f1' }} />
                  <Typography sx={{ fontSize: 14, color: '#6366f1', fontWeight: 700 }}>{images}</Typography>
                </Box>
              )}
              {docs > 0 && (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.3 }}>
                  <DescriptionOutlinedIcon sx={{ fontSize: 18, color: '#16a34a' }} />
                  <Typography sx={{ fontSize: 14, color: '#16a34a', fontWeight: 700 }}>{docs}</Typography>
                </Box>
              )}
            </Box>
          )}

          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.4 }}>
              <ThumbUpAltOutlinedIcon sx={{ fontSize: 18, color: '#22c55e' }} />
              <Typography sx={{ fontSize: 14, color: '#22c55e', fontWeight: 700 }}>{article.totalHelpful || 0}</Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.4 }}>
              <ThumbDownAltOutlinedIcon sx={{ fontSize: 18, color: '#ef4444' }} />
              <Typography sx={{ fontSize: 14, color: '#ef4444', fontWeight: 700 }}>{article.totalUnhelpful || 0}</Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default KBListItem;
